import { createFileRoute, redirect } from '@tanstack/react-router';

type LegacyTimelineBeforeLoadArgs = {
  params: { loopId: number; org: string };
};

export const legacyTimelineBeforeLoad = ({ params }: LegacyTimelineBeforeLoadArgs): never => {
  throw redirect({
    to: '/org/$org/loop/$loopId/portfolio/roadmap',
    params,
    search: true,
    replace: true,
  });
};

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/timeline/')({
  beforeLoad: legacyTimelineBeforeLoad,
});
